import artifact from '$houdini/artifacts/CloseSessionMutation'
import { MutationStore } from '../runtime/stores/mutation'

export class CloseSessionMutationStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
